<div class="mb-3" [class.invalid-feedback]="showError" *ngIf="model.code">
  <a [href]="model.link" target="_blank">
    <img [src]="youtubeVideoService.getSrc(model)" alt="">
  </a>
</div>
